export enum EventName {
  // 10月9日
  extract_hashtag_start_click = 'extract_hashtag_start_click',
  extract_hashtag_add_credit_click = 'extract_hashtag_add_credit_click',
  extract_keyword_start_click = 'extract_keyword_start_click',
  extract_keyword_add_credit_click = 'extract_keyword_add_credit_click',
  extract_location_start_click = 'extract_location_start_click',
  extract_location_add_credit_click = 'extract_location_add_credit_click',
  extract_followers_start_click = 'extract_followers_start_click',
  extract_followers_add_credit_click = 'extract_followers_add_credit_click',
  extract_followings_start_click = 'extract_followings_start_click',
  extract_followings_add_credit_click = 'extract_followings_add_credit_click',
  extract_profile_start_click = 'extract_profile_start_click',
  extract_profile_add_credit_click = 'extract_profile_add_credit_click',
  extract_all_start_click = 'extract_all_start_click',
  extract_all_add_credit_click = 'extract_all_add_credit_click',
  export_profiles_click = 'export_profiles_click',
  export_emails_click = 'export_emails_click',

  affiliate_apply_click = 'affiliate_apply_click',

  //2025.7.17
  click_export_upgrade_now = 'click_export_upgrade_now',
  click_export_download_excel = 'click_export_download_excel',
  click_export_download_csv = 'click_export_download_csv',
  click_export_upgrade_plan = 'click_export_upgrade_plan',

  post_comment_s_n = 'post_comment_s_n',
  comment_load_more_btn_to_login = 'comment_load_more_btn_to_login',
  comment_upgrade_paywall_shown = 'comment_upgrade_paywall_shown',
  comment_upgrade_now_click = 'comment_upgrade_now_click',
  comment_export_click = 'comment_export_click',
  comment_export_all_btn_to_login = 'comment_export_all_btn_to_login',
  sentiment_breakdown_click = 'sentiment_breakdown_click',
  account_performance_click = 'account_performance_click',

  // 2025.5.25
  view_stories_for_free = 'view_stories_for_free',
  reward_watch_video_click = 'reward_watch_video_click',
  reward_x_click = 'reward_x_click',
  reward_reddit_click = 'reward_reddit_click',

  post_likes_s_n = 'post_likes_s_n',
  likes_search_input = 'likes_search_input',

  // 2025.7.8
  view_stories_for_free_trial = 'view_stories_for_free_trial',

  login = 'login',
  sign_up = 'sign_up',
  search = 'search',
  begin_checkout = 'begin_checkout',
  purchase = 'purchase',
  purchase_fail = 'purchase_fail',

  // header
  header_Home = 'header_Home',
  header_Plan = 'header_Plan',
  header_FAQ = 'header_FAQ',
  header_Analytics_Sample = 'header_Analytics_Sample',
  header_star_data = 'header_star_data',
  header_Toolkit = 'header_Toolkit',
  header_Blog = 'header_Blog',
  header_SignIn = 'header_SignIn',
  header_Dashboard = 'header_Dashboard',
  header_Settings = 'header_Settings',
  header_Payment_History = 'header_Payment_History',
  header_Logout = 'header_Logout',
  header_view_instagram_anonymously = 'header_view_instagram_anonymously',
  header_web_viewer_for_instagram = 'header_web_viewer_for_instagram',
  header_web_ig_recent_follower_tracker = 'header_web_ig_recent_follower_tracker',
  header_web_ig_unfollowers_tracker = 'header_web_ig_unfollowers_tracker',
  header_web_hashtag_generator_for_instagram = 'header_web_hashtag_generator_for_instagram',
  header_web_ig_shadowban_checker = 'header_web_ig_shadowban_checker',
  header_ig_follower_export_tool = 'header_ig_follower_export_tool',
  header_Search_History = 'header_Search_History',
  header_Features = 'header_Features',
  header_Affiliate = 'header_Affiliate',

  header_Features_ViewInstagramAnonymously = 'header_Features_ViewInstagramAnonymously',
  header_Features_TrackInstagramAnonymously = 'header_Features_TrackInstagramAnonymously',
  header_Features_DownloadInstagramStories = 'header_Features_DownloadInstagramStories',
  header_Features_InstagramViewer = 'header_Features_InstagramViewer',
  header_Features_DiscoverInstagramInfluencerTrends = 'header_Features_DiscoverInstagramInfluencerTrends',
  header_Features_MonitorSuspiciousInstagramActivity = 'header_Features_MonitorSuspiciousInstagramActivity',

  // login
  // login_Google = 'login_Google',
  // login_Sign_In = 'login_Sign_In',
  // login_Sign_Up = 'login_Sign_Up',
  login_Forgot_Password = 'login_Forgot_Password',

  // home
  home_See_Analytics_Sample = 'home_See_Analytics_Sample',
  home_ADD_ACCOUNT = 'home_ADD_ACCOUNT',
  sample_ADD_ACCOUNT = 'sample_ADD_ACCOUNT',

  // dashboard
  dashboard_ADD_ACCOUNT = 'dashboard_ADD_ACCOUNT',
  dashboard_See_Analytics = 'dashboard_See_Analytics',
  dashboard_Buy_past_reports = 'dashboard_Buy_past_reports',
  dashboard_Buy_past_reports_btn = 'dashboard_Buy_past_reports_btn',
  dashboard_Delete = 'dashboard_Delete',
  dashboard_Check = 'dashboard_Check',
  dashboard_Add_new_account = 'dashboard_Add_new_account',

  // settings
  settings_Password_Change = 'settings_Password_Change',
  settings_Plan_Stop = 'settings_Plan_Stop',
  settings_Plan_Subscription = 'settings_Plan_Subscription',
  settings_Logout = 'settings_Logout',
  settings_Delete_Account = 'settings_Delete_Account',

  // 访问用户数：
  // 初次访问用户数：first_visit
  // 点击注册用户数：
  Login_View = 'login_View',

  // 注册成功用户数：
  user_register_Success = 'user_register_Success',
  // 注册失败用户数：
  user_register_Fail = 'user_register_Fail',
  // 登录用户数：
  user_Login_Success = 'user_Login_Success',

  // 登录用户样本分析访问用户数：
  Sample_View = 'sample_View',
  // 样本详情页访问用户数（3个样本页面排重后的合集用户）：
  Sample_See_Analytics = 'sample_See_Analytics',
  // 点击“Ckeck”用户数（只要尝试点击ADD ACCOUNT，一定添加成功）：
  // dashboard_Check = 'dashboard_Check',
  // “ADD ACCOUNT”成功添加用户数：
  Add_Account_Request_Success = 'add_Account_Request_Success',
  // Plan页面访问用户数：
  Plan_View = 'plan_View',
  // Plan页面点击“Subscribe”用户数：
  Plan_Subscribe_Request_Before = 'plan_Subscribe_Request_Before',
  // “Subscribe”成功用户数：
  Plan_Subscribe_Request_Success = 'Plan_Subscribe_Request_After',
  // “Subscribe”失败用户数：
  Plan_Subscribe_Request_Fail = 'plan_Subscribe_Request_Fail',

  // 点击“Buy past report”用户数：
  // dashboard_Buy_past_reports = 'dashboard_Buy_past_reports',
  // “Buy past report”成功用户数：
  Buy_Past_Report_Request_Success = 'buy_Past_Report_Request_Success',
  // “Buy past report”失败用户数：
  Buy_Past_Report_Request_Fail = 'buy_Past_Report_Request_Fail',

  // 关闭
  Article_Bottom_Banner_Close_Icon = 'Article_Bottom_Banner_Close_Icon',
  // 跳转
  Article_Bottom_Banner_Click = 'Article_Bottom_Banner_Click',

  // 名人追踪详情页面点击“ADD Account”
  starInfo_Top_AddAccount = 'starInfo_Top_AddAccount',
  // 名人追踪详情页Activity Report引导解锁弹窗触发次数：
  starInfo_ActivityReport = 'starInfo_ActivityReport',
  // 名人追踪详情页Activity Report引导解锁弹窗点击“Unlock Now”按钮次数：
  starInfo_ActivityReport_UnlockNow = 'starInfo_ActivityReport_UnlockNow',
  // 名人追踪详情页Activity Report弹窗点击“View Sample Report”按钮次数：
  starInfo_ActivityReport_ViewSampleReport = 'starInfo_ActivityReport_ViewSampleReport',
  // Web niewer for instagramy引导banner点击“Add Account to Track”次数（包含功能介绍页和查询结果页）：
  WebViewerforInstagram_AddAccountToTrack = 'WebViewerforInstagram_AddAccountToTrack',
  // View Instagram Stories Anonymously点击“SEE ANALYSIS ViewInstagramStoriesAnonymously_SeeAnalysisSample
  ViewInstagramStoriesAnonymously_SeeAnalysisSample = 'ViewInstagramStoriesAnonymously_SeeAnalysisSample',
  // View Instagram Stories Anonymously查询次数上限提示弹窗弹出次数：ViewInstagramStoriesAnonymously_OutOfViews
  ViewInstagramStoriesAnonymously_OutOfViews = 'ViewInstagramStoriesAnonymously_OutOfViews',
  // View Instagram Stories Anonymously页面查询次数上限弹窗，点击“Add Account Now”次数：
  ViewInstagramStoriesAnonymously_OutOfViews_AddAccountNow = 'ViewInstagramStoriesAnonymously_OutOfViews_AddAccountNow',

  Story_OutOfViews_AddAccountNow = 'Story_OutOfViews_AddAccountNow',

  //
  Blog_Detail_Bottom_RecentFollow_Btn = 'Blog_Detail_Bottom_RecentFollow_Btn',
  //
  Blog_Detail_Bottom_AddAccount_Btn = 'Blog_Detail_Bottom_AddAccount_Btn',

  //
  Unlock_Bottom_StartTrackingNow_Btn = 'Unlock_Bottom_StartTrackingNow_Btn',

  // Stories
  // 点击search now 用户数：search_now_clicks
  GA_search_now_clicks = 'search_now_clicks',
  // search now 到达上限弹窗出现次数：search_now_limit_notify_displayed
  GA_search_now_limit_notify_displayed = 'search_now_limit_notify_displayed',
  // search now 到达上限弹窗点击次数：search_now_limit_notify_clicked
  GA_search_now_limit_notify_clicked = 'search_now_limit_notify_clicked',
  GA_account_limit_reached_notify_clicked = 'account_limit_reached_notify_clicked',
  // 一键下载弹窗出现次数：one_click_displayed
  GA_one_click_displayed = 'one_click_displayed',
  // 一键下载弹窗点击次数：one_click_clicked
  GA_one_click_clicked = 'one_click_clicked',
  // story详情页底部添加追踪按钮点击次数：add_tracking_button_clicks
  GA_add_tracking_button_clicks = 'add_tracking_button_clicks',
  // 用户点击Plan页面'Subscribe'：plan_subscribe_clicks
  GA_plan_subscribe_clicks = 'plan_subscribe_clicks',
  // dashboard点击'toolkit'次数 ：insight_button_clicks
  GA_toolkit_button_clicks = 'toolkit_button_clicks',
  // dashboard- search now 点击次数：dashboard_search_clicks
  GA_dashboard_search_clicks = 'dashboard_search_clicks',

  // Threads Downloader
  threads_downloader_s_n = 'threads_downloader_s_n',
  threads_downloader_s_r_view_btn_clicked = 'threads_downloader_s_r_view_btn_clicked',
  threads_downloader_dl_btn_clicked = 'threads_downloader_dl_btn_clicked',
  threads_downloader_dl_btn_c_to_login = 'threads_downloader_dl_btn_c_to_login',
  threads_downloader_dl_btn_c_to_download = 'threads_downloader_dl_btn_c_to_download',

  /**
   * 2025年8月15日新增埋点字段
   * story viewer的四个引流banner cta文案点击：
   */
  banner_recent_follow_cta_click = 'banner_recent_follow_cta_click',
  banner_unfollowers_cta_click = 'banner_unfollowers_cta_click',
  banner_post_comment_cta_click = 'banner_post_comment_cta_click',
  banner_follower_export_cta_click = 'banner_follower_export_cta_click',

  /**
   * 2025年9月16日新增埋点字段
   * 邀请弹窗曝光：referral_popup_impression
   * 邀请弹窗复制链接：referral_popup_copy_link
   * 被邀请人领取优惠券：referral_invitee_claim
   * 领取优惠券后点击前往recent follow页面：referral_claim_to_rf_click
   */
  referral_popup_impression = 'referral_popup_impression',
  referral_popup_copy_link = 'referral_popup_copy_link',
  referral_invitee_claim = 'referral_invitee_claim',
  referral_claim_to_rf_click = 'referral_claim_to_rf_click',
}

// export enum EventSource {
//   ADD_TO_CART = 'ADD_TO_CART',
//   BLOG_PAGE = 'BLOG_PAGE',
//   BROWSE_ALL_CREATOR_SHOPS = 'BROWSE_ALL_CREATOR_SHOPS',
//   BROWSE_CREATORS_BY_ALPHABET = 'BROWSE_CREATORS_BY_ALPHABET',
//   BROWSE_CREATORS_TRENDING_CREATORS = 'BROWSE_CREATORS_TRENDING_CREATORS',
//   CATALOG_ITEMS = 'CATALOG_ITEMS',
//   CLICK_PRINTFUL_BUY_NOW = 'CLICK_PRINTFUL_BUY_NOW',
//   COHORT_LANDING_PAGE_LEARN_MORE = 'COHORT_LANDING_PAGE_LEARN_MORE',
//   CREATOR_INSTAGRAM_SEARCH = 'CREATOR_INSTAGRAM_SEARCH',
//   CREATOR_SHOP = 'CREATOR_SHOP',
//   CREATOR_SHOP_PRODUCT_ITEM = 'CREATOR_SHOP_PRODUCT_ITEM',
//   CREATOR_JOIN_EMAIL = 'CREATOR_JOIN_EMAIL',
//   HOMEPAGE = 'HOMEPAGE',
//   HOMEPAGE_PDF = 'HOMEPAGE_PDF',
//   MARKETPLACE_HOMEPAGE_BANNER = 'MARKETPLACE_HOMEPAGE_BANNER',
//   MARKETPLACE_HOMEPAGE_CONTENT = 'MARKETPLACE_HOMEPAGE_CONTENT',
//   MARKETPLACE_HOMEPAGE_FEATURED_IMAGES = 'MARKETPLACE_HOMEPAGE_FEATURED_IMAGES',
//   MARKETPLACE_HOMEPAGE_SEARCH_TERM = 'MARKETPLACE_HOMEPAGE_SEARCH_TERM',
//   MARKETPLACE_NAV_BAR = 'MARKETPLACE_NAV_BAR',
//   MARKETPLACE_POPULAR_PRODUCT_ITEM = 'MARKETPLACE_POPULAR_PRODUCT_ITEM',
//   MORE_FROM_THIS_CREATOR = 'MORE_FROM_THIS_CREATOR',
//   NEW_AND_TRENDING_FEATURED_CAROUSEL = 'NEW_AND_TRENDING_FEATURED_CAROUSEL',
//   NEW_AND_TRENDING_HEADER = 'NEW_AND_TRENDING_HEADER',
//   NEW_AND_TRENDING_NEWEST = 'NEW_AND_TRENDING_NEWEST',
//   NEW_AND_TRENDING_POPULAR = 'NEW_AND_TRENDING_POPULAR',
//   PIETRA_PARTNERS_LANDING_PAGE = 'PIETRA_PARTNERS_LANDING_PAGE',
//   PRICING_PAGE = 'PRICING_PAGE',
//   PRODUCT_DETAILS_PAGE = 'PRODUCT_DETAILS_PAGE',
//   PRODUCT_DETAILS_PAGE_FOOTER = 'PRODUCT_DETAILS_PAGE_FOOTER',
//   PRODUCT_GRID_ITEM_SHOP_AVATAR = 'PRODUCT_GRID_ITEM_SHOP_AVATAR',
//   RECENTLY_VIEWED_PRODUCTS = 'RECENTLY_VIEWED_PRODUCTS',
//   SEARCH_TERMS = 'SEARCH_TERMS',
//   SETUP_COMMERCE = 'SETUP_COMMERCE',
//   SHOP_ALL_FEATURED = 'SHOP_ALL_FEATURED',
//   SHOP_ALL_FILTERS = 'SHOP_ALL_FILTERS',
//   SHOP_ALL_POPULAR_PRODUCT = 'SHOP_ALL_POPULAR_PRODUCT',
//   SHOP_ALL_PRODUCT_GRID_ITEM = 'SHOP_ALL_PRODUCT_GRID_ITEM',
//   WEBSITE_NAV_BAR = 'MARKETPLACE_NAV_BAR',
// }
